import offlineConfig from '@redux-offline/redux-offline/lib/defaults';
import { getRequest, postRequest, putRequest, deleteRequest } from 'src/utils/request-client'

const config = {
  ...offlineConfig,
  effect: (effect, action) => {
    //NOTE! Need to always return a response
    if (!effect) {
      return Promise.resolve({})
    }

    // Will return effect if we have a function instead of object
    if (typeof effect === 'function') {
      return effect()
    }

    switch (effect.method) {
      case "GET":
        return getRequest(effect.query)
      case "POST":
        return postRequest(effect.query, action.payload)
      case "PUT":
        return putRequest(effect.query, action.payload)
      case "DELETE":
        return deleteRequest(effect.query, { data: action.payload })
      default:
        return getRequest(effect.query)
    }
  },
  rehydrate: true,
  persistOptions: {
    blacklist: [
      'reviewReducer',
      'nonPersistentAppReducer',
    ]
  }
}

export default config
